import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0a112ac8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

import { ref, onMounted, watch } from 'vue';
import moment from "moment";


export default /*#__PURE__*/_defineComponent({
  __name: 'DateTimePickerComponent',
  props: {
  label: {type: String, default: null },
  placeholder: { type: String, default: null },
  selected: { default: null },
  width: { type: String, default: '100%' },
  displayFormat: { type: String },
  format: { type: String, default: null },
  type: { type: String, default: null },
  disableClearIcon: { type: Boolean, default: false }
},
  emits: ['update:dateTime'],
  setup(__props, { emit: __emit }) {

const props = __props
const dialog = ref(false);
const date = ref<any>(null);
const dateTime = ref<any>(null);
const inputIcon = ref('mdi-calendar');

const emit = __emit;
let hours: any[] = Array.from({ length: 24 }, (_, x) => ({ title: (x < 10 ? '0' + x : '' + x).toString(), value: x }));
let minutes: any[] = Array.from({ length: 60 }, (_, i) => ({ title: (i < 10 ? '0' + i : '' + i).toString(), value: i }));
const selectedHour = ref<any>(moment().hour());
const selectedMinute = ref<any>(moment().minute());

onMounted(() => {
  // For time usage
  if(props.type === 'time') {
    inputIcon.value = 'mdi-clock';
    if(props.selected) { setTime();}
  } else if(props.type === 'date') {
    setDate();
  }else {
    if(props.selected) {
      setTime();
      setDate();
    }
  }
});

watch([selectedHour, selectedMinute, date], () => {
  let formatDate;
  if(props.type === 'time') {
    if(selectedHour.value !== null && selectedMinute.value !== null) {
      dateTime.value = moment().hour(selectedHour.value).minute(selectedMinute.value).format('LT');
      formatDate = moment(dateTime.value, 'LT').format(props.format ? props.format : 'YYYY-MM-DD HH:mm a');
    }
  } else if(props.type === 'date') {
    if(date.value) {
      dateTime.value = moment(date.value).format('MM/DD/YYYY');
      formatDate = moment(dateTime.value, 'MM/DD/YYYY').format(props.format ? props.format : 'YYYY-MM-DD HH:mm a');
    }
  } else {
    if(date.value) {
       selectedHour.value = selectedHour.value !== null ? selectedHour.value : moment().hour();
       selectedMinute.value = selectedMinute.value !== null ?  selectedMinute.value : moment().minute();
      dateTime.value = moment(date.value).hour(selectedHour.value).minute(selectedMinute.value).format('MM/DD/YYYY hh:mm a');
      formatDate = moment(dateTime.value, 'MM/DD/YYYY hh:mm a').format(props.format ? props.format : 'YYYY-MM-DD HH:mm a');
    }
  }
  emit('update:dateTime', formatDate);
});

function setTime() {
  const time = moment(props.selected,  "HH:mm:ss").format('LT');
  if(time !== 'Invalid date') {
    dateTime.value = time;
    selectedHour.value = moment(time, 'LT').hours();
    selectedMinute.value = moment(time, 'LT').minutes();
  }
}
function setDate() {
  if (props.selected) {
    const setdate = moment(props.selected, moment.ISO_8601, true).isValid() ? moment(props.selected) : moment(props.selected, props.format, true);
    dateTime.value = setdate.format('MM/DD/YYYY hh:mm a');
    if (setdate.isValid()) {
      selectedHour.value = setdate.hour();
      selectedMinute.value = setdate.minute();
      date.value = setdate.toDate();
    }
  }
}

function handleDateClear() {
  date.value = null;
  dateTime.value = null;
  selectedHour.value = 0;
  selectedMinute.value = 0;
}

return (_ctx: any,_cache: any) => {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_text_field, {
      modelValue: dateTime.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dateTime).value = $event)),
      readonly: "",
      "persistent-clear": "",
      "append-inner-icon": inputIcon.value,
      density: "compact",
      label: __props.label,
      placeholder: __props.placeholder ? __props.placeholder : __props.label,
      "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (handleDateClear())),
      style: _normalizeStyle({ minWidth: '270px', maxWidth: __props.width }),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (dialog.value = true)),
      variant: "outlined",
      clearable: !props.disableClearIcon,
      "hide-details": ""
    }, null, 8 /* PROPS */, ["modelValue", "append-inner-icon", "label", "placeholder", "style", "clearable"]),
    _createVNode(_component_v_dialog, {
      class: "remove-transition",
      modelValue: dialog.value,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialog).value = $event)),
      width: "450"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[7] || (_cache[7] = ($event: any) => (dialog.value = false)),
          class: "outer-wrap"
        }, [
          _createElementVNode("div", {
            onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (dialog.value = true), ["stop"])),
            class: "wrapper rounded-lg bg-white"
          }, [
            (props.type != 'time')
              ? (_openBlock(), _createBlock(_component_v_row, { key: 0 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_date_picker, {
                      elevation: "0",
                      modelValue: date.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((date).value = $event)),
                      title: "Select Date and Time",
                      class: "my-6 mx-auto",
                      scrollable: "",
                      "hide-actions": "",
                      "no-title": "",
                      "show-current": "",
                      "hide-header": true
                    }, null, 8 /* PROPS */, ["modelValue"])
                  ]),
                  _: 1 /* STABLE */
                }))
              : (_openBlock(), _createBlock(_component_v_row, { key: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1 /* STABLE */
                })),
            (props.type != 'date')
              ? (_openBlock(), _createBlock(_component_v_row, {
                  key: 2,
                  class: "px-md-4",
                  style: {"width":"380px","margin":"auto"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, {
                      lg: "6",
                      md: "6",
                      cols: "5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          items: _unref(hours),
                          modelValue: selectedHour.value,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((selectedHour).value = $event)),
                          label: "Hour",
                          density: "compact"
                        }, null, 8 /* PROPS */, ["items", "modelValue"])
                      ]),
                      _: 1 /* STABLE */
                    }),
                    _createVNode(_component_v_col, {
                      lg: "6",
                      md: "6",
                      cols: "5"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          items: _unref(minutes),
                          modelValue: selectedMinute.value,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedMinute).value = $event)),
                          label: "Minutes",
                          density: "compact"
                        }, null, 8 /* PROPS */, ["items", "modelValue"])
                      ]),
                      _: 1 /* STABLE */
                    })
                  ]),
                  _: 1 /* STABLE */
                }))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["modelValue"])
  ]))
}
}

})